import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import { topicCategories } from '@/mocks/home';

const heatStyles: Record<string, string> = {
  热: 'bg-primary-100 text-primary-700',
  温: 'bg-secondary-100 text-secondary-900',
  新: 'bg-accent-100 text-accent-800',
};

export default function TopicsSection() {
  const [activeKey, setActiveKey] = useState(topicCategories[0].key);
  const active = topicCategories.find((item) => item.key === activeKey) ?? topicCategories[0];

  return (
    <section id="topics" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <SectionHeading
          eyebrow="热门分类"
          title="六大热门分区，各有一套吃瓜路线"
          desc="不同分区的节奏完全不同。点开下面的分类，看看每个方向应该重点关注什么、按什么顺序跟进。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 md:mt-14 lg:grid-cols-[280px_1fr] lg:gap-8">
          <div
            className="flex gap-2 overflow-x-auto pb-1 lg:flex-col lg:gap-2 lg:overflow-visible lg:pb-0"
            role="tablist"
            aria-label="热门吃瓜分类"
          >
            {topicCategories.map((category) => {
              const isActive = category.key === activeKey;
              return (
                <button
                  key={category.key}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setActiveKey(category.key)}
                  className={`flex shrink-0 items-center gap-2.5 whitespace-nowrap rounded-md px-4 py-3 font-label text-sm transition-colors lg:w-full ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : 'border border-background-300/70 bg-background-50 text-foreground-700 hover:bg-background-200/60'
                  }`}
                >
                  <i className={`${category.icon} text-lg`} aria-hidden="true"></i>
                  {category.name}
                </button>
              );
            })}
          </div>

          <div className="rounded-lg border border-background-200/80 bg-background-50 p-5 md:p-7">
            <div className="flex items-start gap-3">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${active.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                  {active.name}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{active.desc}</p>
              </div>
            </div>

            <ul className="mt-6 divide-y divide-background-200/80">
              {active.items.map((item) => (
                <li key={item.title} className="flex items-start gap-3 py-3.5">
                  <span
                    className={`mt-0.5 inline-flex h-6 shrink-0 items-center rounded-full px-2 font-label text-xs font-medium ${
                      heatStyles[item.heat] ?? 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    {item.heat}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium leading-snug text-foreground-900">{item.title}</p>
                    <p className="mt-1 font-label text-xs text-foreground-500">{item.time}</p>
                  </div>
                  <i className="ri-arrow-right-s-line mt-0.5 shrink-0 text-lg text-foreground-400" aria-hidden="true"></i>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}